import AnimatedMenu from '../AnimatedMenu'
import DarkLogo from './images/DWP-logo-dark.png'
import LightLogo from './images/DWP-light.png'
import FirstRepairLogo from './images/FirstRepair-logo.png'
import FirstRepairLogoWhite from './images/FR_logo_white.png'

import hamburgerIcon from './images/hamburger-icon.svg'
import hamburgerIconLight from './images/hamburger-icon-light.svg'
import mobileDWPLogo from './images/DWP_mobile_logo.svg'
import mobileDWPLogoLight from './images/DWP_mobile_logo_light.svg'
import mobileDWPLogoBlue from './images/DWP_logo-blue.svg'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DesktopMenu, MobileMenu } from './components'

interface NavBarProps {
  theme?: 'light' | 'dark'
  blueVariant?: boolean
}

function NavBar({ theme = 'light', blueVariant = false }: NavBarProps) {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
  const navigate = useNavigate()
  const onNavigate = (path: string) => {
    setIsMenuOpen(false)
    navigate(path)
    //  THIS IS TEMPORARY. PREVENTS USERS FROM GOING TO ANY PAGE OTHER THAN FORM.
    // if (path !== '/add-organization') {
    //   window.location.reload()
    // }
  }

  const handleIsMenuOpenChange = (state: boolean) => {
    setIsMenuOpen(state)
  }
  return (
    <nav className="w-full flex justify-between items-center mt-8 mb-0 sm:mb-16">
      <div className="flex items-center">
        <a href="https://firstrepair.org" className="pl-0">
          <img
            alt="Circles with FirstRepair below"
            className="max-w-[225px] h-auto align-middle border-none w-[90%]"
            src={theme === 'light' ? FirstRepairLogoWhite : FirstRepairLogo}
          />
        </a>
        <a href="https://decolonizingwealth.com" className="pr-4 sm:pl-6">
          <img
            alt="W over squiggly line with Decolonizing Wealth Project to the right"
            className="max-w-[225px] h-auto align-middle border-none hidden sm:block"
            src={theme === 'light' ? LightLogo : DarkLogo}
          />
          <img
            alt="W over squiggly line"
            src={
              blueVariant
                ? mobileDWPLogoBlue
                : theme === 'light'
                ? mobileDWPLogoLight
                : mobileDWPLogo
            }
            className="block sm:hidden"
          />
        </a>
      </div>
      <div className="hidden sm:block">
        <AnimatedMenu
          onIsMenuOpenChange={handleIsMenuOpenChange}
          theme={theme}
        />
      </div>
      <div className="flex sm:hidden">
        {!isMenuOpen && (
          <img
            src={theme === 'light' ? hamburgerIconLight : hamburgerIcon}
            alt="Three lines on top of each other"
            role="button"
            onClick={() => setIsMenuOpen(true)}
          />
        )}
      </div>
      {isMenuOpen && (
        <>
          <div className="block sm:hidden">
            <MobileMenu
              onNavigate={onNavigate}
              onIsMenuOpenChange={handleIsMenuOpenChange}
            />
          </div>
          <div className="hidden sm:block">
            <DesktopMenu
              onNavigate={onNavigate}
              onIsMenuOpenChange={handleIsMenuOpenChange}
            />
          </div>
        </>
      )}
    </nav>
  )
}

export default NavBar
